import { Link, Navigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { nip19 } from 'nostr-tools';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { EditProfileForm } from '@/components/EditProfileForm';

export function EditProfile() {
  const { user } = useCurrentUser();

  // Redirect to home if not logged in
  if (!user) {
    return <Navigate to="/" replace />;
  }

  const npub = nip19.npubEncode(user.pubkey);

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-200 via-amber-100 via-emerald-100 to-sky-200 dark:from-rose-950 dark:via-violet-950 dark:to-sky-950">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-background border-b border-border safe-top-mobile">
        <div className="max-w-xl mx-auto px-5 py-4 flex items-center gap-4">
          <Link
            to={`/${npub}`}
            className="p-2 -ml-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10"
          >
            <ArrowLeft className="h-6 w-6 text-foreground" />
          </Link>
          <span className="text-lg font-medium text-foreground">Edit Profile</span>
        </div>
      </header>

      <main className="max-w-xl mx-auto px-5 py-8 safe-bottom">
        <div className="bg-white/60 dark:bg-black/30 backdrop-blur-sm rounded-3xl p-6">
          <EditProfileForm />
        </div>
      </main>
    </div>
  );
}

export default EditProfile;
